export const removeEmptyProps = obj =>
  Object.fromEntries(
    Object.entries(obj).
      filter(([, v]) => v != null).
      map(([k, v]) => (typeof v === 'object' ? [k, removeEmptyProps(v)] : [k, v])),
  )
